const images = [
  {
    id: 1,
    type: "lommen",
    title: "I jakkelomma i skogen",
    description: "Har du en flaske i lomma eller er du bare glad for å se meg?",
    img: "f-j.jpg",
    filter_incl: [6],
    filter_excl: [21],
    filter_bike: false,
    filter_shame: false,
    filter_socks: false,
  },
  {
    id: 2,
    type: "middel",
    title: "Midtgrep venstre i skogen",
    description:
      "To the left, to the left, hold the bottle in the middle to the left.",
    img: "f-lm.jpg",
    filter_incl: [1, 3],
    filter_excl: [21],
    filter_bike: false,
    filter_shame: false,
    filter_socks: false,
  },
  {
    id: 3,
    type: "topp",
    title: "Toppgrep venstre i skogen",
    description: "Panting kan også være tøft",
    img: "f-lt.jpg",
    filter_incl: [1, 3],
    filter_excl: [21],
    filter_bike: false,
    filter_shame: false,
    filter_socks: false,
  },
  {
    id: 4,
    type: "lommen",
    title: "I bukselomma i skogen",
    description: "Pantebottom jeans!",
    img: "f-p.jpg",
    filter_incl: [4],
    filter_excl: [21],
    filter_bike: false,
    filter_shame: false,
    filter_socks: false,
  },
  {
    id: 5,
    type: "lommen",
    title: "Midtgrep høyre i skogen",
    description: "Halla;)",
    img: "f-rm.jpg",
    filter_incl: [2, 3],
    filter_excl: [21],
    filter_bike: false,
    filter_shame: false,
    filter_socks: false,
  },
  {
    id: 6,
    type: "topp",
    title: "Toppgrep høyre i skogen",
    description: "Toppgrep er topp grep som vi sier i Infinitum",
    img: "f-rt.jpg",
    filter_incl: [2, 3],
    filter_excl: [21],
    filter_bike: false,
    filter_shame: false,
    filter_socks: false,
  },
  {
    id: 7,
    type: "topp",
    title: "I sekken i skogen",
    description: "Hvilken flaske? ;-)",
    img: "f-s.jpg",
    filter_incl: [5],
    filter_excl: [21],
    filter_bike: false,
    filter_shame: true,
    filter_socks: false,
  },
  {
    id: 8,
    type: "topp",
    title: "På sykkel i skogen",
    description: "For de raske holder det med flaskeholder",
    img: "f-b.jpg",
    filter_incl: [7],
    filter_excl: [21],
    filter_bike: true,
    filter_shame: true,
    filter_socks: false,
  },
  {
    id: 10,
    type: "lommen",
    title: "I jakkelomma på stranda",
    description: "Not all heroes wear capes, but some do;)",
    img: "s-j.jpg",
    filter_incl: [6],
    filter_excl: [22],
    filter_bike: false,
    filter_shame: false,
    filter_socks: true,
  },
  {
    id: 11,
    type: "middel",
    title: "Midtgrep venstre på stranda",
    description:
      "Ring meg når du skal til stranda, vi skal pante alt i sommer, vi skal pante som om regninga aldri kommer",
    img: "s-lm.jpg",
    filter_incl: [1, 3],
    filter_excl: [22],
    filter_bike: false,
    filter_shame: false,
    filter_socks: true,
  },
  {
    id: 12,
    type: "topp",
    title: "Toppgrep venstre på stranda",
    description: "Flaskepostmann Pat, jo!",
    img: "s-lt.jpg",
    filter_incl: [1, 3],
    filter_excl: [22],
    filter_bike: false,
    filter_shame: false,
    filter_socks: true,
  },
  {
    id: 13,
    type: "lommen",
    title: "I bukselomma på stranda",
    description: "Fancy pant!",
    img: "s-p.jpg",
    filter_incl: [4],
    filter_excl: [22],
    filter_bike: false,
    filter_shame: false,
    filter_socks: true,
  },
  {
    id: 14,
    type: "lommen",
    title: "Midtgrep høyre på stranda",
    description: "Morra di panter ikke her",
    img: "s-rm.jpg",
    filter_incl: [2, 3],
    filter_excl: [22],
    filter_bike: false,
    filter_shame: false,
    filter_socks: true,
  },
  {
    id: 15,
    type: "topp",
    title: "Toppgrep høyre på stranda",
    description:
      "Unnskyld, vet du veien til ... *flexer armen*... panteautomaten?",
    img: "s-rt.jpg",
    filter_incl: [2, 3],
    filter_excl: [22],
    filter_bike: false,
    filter_shame: false,
    filter_socks: true,
  },
  {
    id: 16,
    type: "topp",
    title: "I sekken på stranda",
    description: "Ikke en flaske så langt øyet kan se",
    img: "s-s.jpg",
    filter_incl: [5],
    filter_excl: [22],
    filter_bike: false,
    filter_shame: true,
    filter_socks: true,
  },
  {
    id: 17,
    type: "topp",
    title: "På sykkel på stranda",
    description: "Men er det ikke Marco Pantani?",
    img: "s-b.jpg",
    filter_incl: [7],
    filter_excl: [22],
    filter_bike: true,
    filter_shame: true,
    filter_socks: true,
  },
  {
    id: 18,
    type: "topp",
    title: "I sekken på stranda",
    description: "Har du kjøpt flaska i sekken sa du ;-)",
    img: "s-s2.jpg",
    filter_incl: [5],
    filter_excl: [22],
    filter_bike: false,
    filter_shame: true,
    filter_socks: false,
  },
  {
    id: 20,
    type: "lommen",
    title: "I jakkelomma på fjellet",
    description: "Lytt til erfarne pantefolk / Aldri for sent å pante / Osv",
    img: "w-j.jpg",
    filter_incl: [6],
    filter_excl: [20],
    filter_bike: false,
    filter_shame: false,
    filter_socks: false,
  },
  {
    id: 21,
    type: "middel",
    title: "Midtgrep venstre på fjellet",
    description: "These boots are made for pantin´",
    img: "w-lm.jpg",
    filter_incl: [1, 3],
    filter_excl: [20],
    filter_bike: false,
    filter_shame: false,
    filter_socks: false,
  },
  {
    id: 22,
    type: "topp",
    title: "Toppgrep venstre på fjellet",
    description:
      "I got one hand in my pocket, and the other one’s holding a bottle",
    img: "w-lt.jpg",
    filter_incl: [1, 3],
    filter_excl: [20],
    filter_bike: false,
    filter_shame: false,
    filter_socks: false,
  },
  {
    id: 23,
    type: "lommen",
    title: "I bukselomma på fjellet",
    description: "No junk in this trunk!",
    img: "w-p.jpg",
    filter_incl: [4],
    filter_excl: [20],
    filter_bike: false,
    filter_shame: false,
    filter_socks: false,
  },
  {
    id: 24,
    type: "lommen",
    title: "På fjellet med flasken i høyre hånd",
    description:
      "Du tar grep om plastforsøpling. Midtgrep høyre for å være nøyaktig.",
    img: "w-rm.jpg",
    filter_incl: [2, 3],
    filter_excl: [20],
    filter_bike: false,
    filter_shame: false,
    filter_socks: false,
  },
  {
    id: 25,
    type: "topp",
    title: "Toppgrep høyre på fjellet",
    description: "Jasså, på topptur?",
    img: "w-rt.jpg",
    filter_incl: [2, 3],
    filter_excl: [20],
    filter_bike: false,
    filter_shame: false,
    filter_socks: false,
  },
  {
    id: 26,
    type: "topp",
    title: "I sekken på fjellet",
    description: "Panten i bånn!",
    img: "w-s.jpg",
    filter_incl: [5],
    filter_excl: [20],
    filter_bike: false,
    filter_shame: true,
    filter_socks: false,
  },
  {
    id: 27,
    type: "topp",
    title: "På sykkel i fjellet",
    description: " &#9835; Sykler i snøen har sin egen pant  &#9835; ",
    img: "w-b.jpg",
    filter_incl: [7],
    filter_excl: [20],
    filter_bike: true,
    filter_shame: true,
    filter_socks: false,
  },
  {
    id: 30,
    type: "lommen",
    title: "I jakkelomma i studio",
    description:
      "Ingen delfiner eller sjøfugl ble skadet under dette fotoopptaket.",
    img: "st-j.jpg",
    filter_incl: [6],
    filter_excl: [23],
    filter_bike: false,
    filter_shame: false,
    filter_socks: false,
  },
  {
    id: 31,
    type: "middel",
    title: "Midtgrep venstre i studio",
    description: "She´s a pant man, skibbedibbedippdippbappbaddapo",
    img: "st-lm.jpg",
    filter_incl: [1, 3],
    filter_excl: [23],
    filter_bike: false,
    filter_shame: false,
    filter_socks: false,
  },
  {
    id: 32,
    type: "topp",
    title: "Toppgrep venstre i studio",
    description: "Deg i pantekøen",
    img: "st-lt.jpg",
    filter_incl: [1, 3],
    filter_excl: [23],
    filter_bike: false,
    filter_shame: false,
    filter_socks: false,
  },
  {
    id: 33,
    type: "lommen",
    title: "I bukselomma i studio",
    description: "Flasker har vi på bakrommet",
    img: "st-p.jpg",
    filter_incl: [4],
    filter_excl: [23],
    filter_bike: false,
    filter_shame: false,
    filter_socks: false,
  },
  {
    id: 34,
    type: "lommen",
    title: "Midtgrep høyre i studio",
    description: "En panter i profil",
    img: "st-rm.jpg",
    filter_incl: [2, 3],
    filter_excl: [23],
    filter_bike: false,
    filter_shame: false,
    filter_socks: false,
  },
  {
    id: 35,
    type: "topp",
    title: "Toppgrep høyre i studio",
    description: "Som en slags stokk, bare kort.",
    img: "st-rt.jpg",
    filter_incl: [2, 3],
    filter_excl: [23],
    filter_bike: false,
    filter_shame: false,
    filter_socks: false,
  },
  {
    id: 36,
    type: "topp",
    title: "I sekken på studio",
    description: "Merk at flasken her ligger skjult i sekken",
    img: "st-s.jpg",
    filter_incl: [5],
    filter_excl: [23],
    filter_bike: false,
    filter_shame: true,
    filter_socks: false,
  },
  {
    id: 37,
    type: "topp",
    title: "På sykkel i studio",
    description: "A true recyclist!",
    img: "st-b.jpg",
    filter_incl: [7],
    filter_excl: [23],
    filter_bike: true,
    filter_shame: true,
    filter_socks: false,
  },
];
export default images;
